import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  inputStyle,
  inputContainerStyle,
  loadingContainer,
  submitButtonStyle,
  errorMsgStyle,
} from "./summarization_request_styles";
import { Spin } from "antd";
import { addPlaylist } from "@sharpana/auth/api_client/summarization_api";

interface AddPlaylistProps {
  onSuccess?: () => void;
}

export const AddPlaylist = ({ onSuccess }: AddPlaylistProps) => {
  const [inputValue, setInputValue] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [dots, setDots] = useState(0);

  const navigate = useNavigate();

  useEffect(() => {
    return () => {
      // Cleanup any pending operations
      setLoading(false);
    };
  }, []);

  // Manage loading dots animation
  useEffect(() => {
    if (!loading) return;

    const timer = setInterval(() => {
      setDots((prev) => (prev + 1) % 4);
    }, 300);

    return () => clearInterval(timer);
  }, [loading]);

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  async function handleSubmitPlaylist() {
    setLoading(true);
    setErrorMsg("");
    try {
      const result = await addPlaylist(inputValue);
      if (result.error) {
        setErrorMsg(result.error);
      } else {
        // Call the onSuccess callback if provided
        if (onSuccess) {
          onSuccess();
        }
        
        // Only navigate if we're not already on the collections page
        if (window.location.pathname !== "/") {
          navigate("/");
        }
      }
    } catch (error) {
      setErrorMsg(
        error.message ||
          "Failed to add playlist, please try again! If the issue persists contact support"
      );
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      {!!errorMsg && <div css={errorMsgStyle}>{errorMsg}</div>}
      {loading ? (
        <div css={loadingContainer}>
          <Spin size="large" />
          <div>
            Fetching playlist details. <br />
            This may take a few seconds
            {".".repeat(dots)}
          </div>
        </div>
      ) : (
        <>
          <div css={inputContainerStyle}>
            <input
              type="text"
              placeholder="YouTube playlist link"
              value={inputValue}
              onChange={handleInputChange}
              css={inputStyle}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSubmitPlaylist();
                }
              }}
            />
            <div
              onClick={handleSubmitPlaylist}
              disabled={loading}
              css={submitButtonStyle}
            >
              Connect
            </div>
          </div>
        </>
      )}
    </>
  );
};
